// @flow
import React, { Component } from 'react';
import {
  MdArrowDropDown,
  MdArrowDropUp,
  MdBook,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from 'react-icons/md';
import { Link } from 'react-router-dom';
import './LetterSeriesInfo.scss';

type SquareProps = {
  to?: string | null,
  mode: 'left' | 'right',
};

const Square = ({ to, mode }: SquareProps) => {
  const disabled = !to;
  const icon = mode === 'left' ? <MdKeyboardArrowLeft /> : <MdKeyboardArrowRight />;
  return disabled ? (
    <div className="square disabled">{icon}</div>
  ) : (
    <Link className="square" to={to || '/'}>
      {icon}
    </Link>
  );
};

Square.defaultProps = {
  to: '/',
};

type Props = {
  username: string,
  series: {
    description: string,
    id: string,
    index: number,
    length: number,
    url_slug: string,
    thumbnail: ?string,
    name: string,
    list: { index: number, id: string, title: string, url_slug: string }[],
  },
};

type State = {
  open: boolean,
};

class LetterSeriesInfo extends Component<Props, State> {
  state = {
    open: false,
  };

  onToggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    const { series, username } = this.props;
    const { name, index, length, list } = series;
    const { open } = this.state;

    return (
      <div className="LetterSeriesInfo">
        <div className="top-wrapper">
          <div className="label">
            <MdBook />
            <span>시리즈</span>
          </div>
          <div className="number">
            {index}/{length}
          </div>
        </div>
        <h2>
          <Link to={`/@${username}/series/${series.url_slug}`}>{this.props.series.name}</Link>
        </h2>
        {open && (
          <ol>
            {list.map(item => (
              <li>
                <Link to={`/@${username}/${item.url_slug}`}>{item.title}</Link>
              </li>
            ))}
          </ol>
        )}
        <div className="footer">
          <div className="show-all" onClick={this.onToggle}>
            {open ? <MdArrowDropUp /> : <MdArrowDropDown />}
            목록보기
          </div>
          <div className="controls">
            <Square
              mode="left"
              to={index === 1 ? null : `/@${username}/${list[index - 2].url_slug}`}
            />
            <Square
              mode="right"
              to={index === length ? null : `/@${username}/${list[index].url_slug}`}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LetterSeriesInfo;



// WEBPACK FOOTER //
// ./src/components/letter/LetterSeriesInfo/LetterSeriesInfo.js